// extracted by mini-css-extract-plugin
module.exports = {"Section2JP":"Section2JP_Section2JP__YbQn7"};